import * as React from 'react';
import { observer } from 'mobx-react-lite';
import {
	makeStyles,
	Box,
	Grid,
	Typography,
	Link,
	FormControl,
	Select,
	MenuItem,
	CircularProgress,
} from '@material-ui/core';
import { stores } from '../../store';
import { IAskItems } from '../../types';
import { toJS } from 'mobx';
import AskItems from './AskItems';
import NoItemSelected from './NoItemSelected';

import Esme from './AskEsme';
import Suggestion from './AskFeedback';
import Issue from './AskWorkSpace';
import JobApproval from './AskEsme';
import { PageTitle } from 'components/Design';
import { Helmet } from 'react-helmet';

const useStyles = makeStyles(theme => ({
	frameContainer: {
		margin: '10px 25px',
		width: '100%',
		overflow: 'hidden',
		textAlign: 'left',
		'@media(max-width:1024px)': {
			overflow: 'auto hidden',
		},
	},
	esmeContainer: {
		width: '100%',
		minWidth: '700px',
		height: '100%',
	},
	askContainer: {
		margin: 0,
		width: '504px',
		height: '100%',
		[theme.breakpoints.down('md')]: {
			width: '312px',
		},
	},
	listContainer: {
		width: '100%',
		height: '100%',
		margin: '0px 10px 0 0',
		padding: '20px 10px 0 0',
		background: '#F4F8FC',
		borderRadius: '16px',
	},
	titleContainer: {
		'&:focus': {
			outline: 'none',
		},
	},
	openContainer: {
		margin: theme.spacing(0),
		padding: '55px 0 0 20px',
		height: '100%',
		overflow: 'scroll',
		width: 'calc(100% - 522px)',
		[theme.breakpoints.down('md')]: {
			width: 'calc(100% - 332px)',
		},
	},
	askItemsList: {
		height: 'calc(100% - 64px)',
		minWidth: '260px',
		overflow: 'auto',
		margin: '0',
		padding: '0 10px',
		borderRadius: '16px',
	},
	'@global': {
		'*::-webkit-scrollbar-thumb': {
			backgroundColor: '#007DBA',
		},
		'*::-webkit-scrollbar': {
			width: '6px',
		},
	},
	formControl: {
		margin: theme.spacing(1),
		marginLeft: '0px',

		'&:hover': {
			'& .MuiInputBase-input': {
				backgroundColor: '#007DBA !important',
				color: '#172a3f !important',
			},
			'& > .MuiInputLabel-formControl': {
				color: '#FFFFFF',
			},
			'& .MuiSvgIcon-root': {
				color: '#FFFFFF !important',
			},
		},
		'& > .MuiInputLabel-formControl': {
			lineHeight: 0,
			color: '#007DBA',
			marginTop: '-2px',
		},
		'& .MuiSvgIcon-root': {
			color: '#007DBA !important',
		},
		'& .MuiInputLabel-shrink': {
			color: '#098BBD',
		},
	},
	formSelect: {
		width: '100%',
		'& .MuiSelect-select': {
			border: '2px solid #007DBA',
			background: '#FFFFFF',
			height: '0px',
			borderRadius: '4px',
			padding: '16px',
			paddingTop: '8px',
			paddingBottom: '24px',
			color: '#007DBA',
			'&:focus-visible': {
				border: '2px solid #000000',
			},
		},
	},
	focusformSelect: {
		width: '100%',
		'& .MuiSelect-select': {
			border: '2px solid black',
			background: '#FFFFFF',
			height: '0px',
			borderRadius: '4px',
			padding: '16px',
			paddingTop: '8px',
			paddingBottom: '24px',
			color: '#007DBA',
		},
	},
}));

let askCategoryName = '';
const openAskCard = (categoryType: string, categories: any) => {
	const askCategory = toJS(categories).find((c: any) => c.RequestType === categoryType);
	if (!askCategory) {
		return;
	}
	askCategoryName = askCategory.RequestType;
};

const SentItems = observer(() => {
	const classes = useStyles();
	const user = React.useContext(stores.context.user);
	const appStores = React.useContext(stores.context.appStores);
	const [totalSentItems, setTotalSentItems] = React.useState<any>([]);
	const [filteredSentItems, setFilteredSentItems] = React.useState<any>([]);
	const [loading, setLoading] = React.useState(false);
	const [reasonValue, setReasonValue] = React.useState('all');
	const [cardOpen, setCardOpen] = React.useState(false);
	const [cardItem, setCardItem] = React.useState<IAskItems>();
	const [focusFormSelect, setFocusFormSelect] = React.useState(false);

	React.useEffect(() => {
		user.getSentItems();
	}, []);
	React.useEffect(() => {
		const element = document.querySelector(
			'.MuiSelect-root.MuiSelect-select.MuiSelect-selectMenu.MuiSelect-filled.MuiInputBase-input.MuiFilledInput-input',
		);
		if (element) {
			element.addEventListener('focus', function() {
				setFocusFormSelect(true);
			});
			element.addEventListener('blur', function() {
				setFocusFormSelect(false);
			});
		}
	}, []);

	React.useEffect(() => {
		setTotalSentItems([...user.sentItems, ...user.userSRs]);
		setFilteredSentItems([...user.sentItems, ...user.userSRs]);
		setReasonValue('all');
		totalSentItems.some((sentItem: IAskItems) => {
			sentItem.showOpenCard = false;
		});
	}, [user.sentItems, user.userSRs]);

	const fetchRecentlyCreatedJobs = (pageNo: Number) => {
		setLoading(true);
		user.GetUserCreatedSRs(pageNo).then((res: any) => {
			if (res) {
				setLoading(false);
			}
		});
	};

	const updateFilterValue = (value: string) => {
		setReasonValue(value);
		const requestType = {
			jobupdate: 'Esme',
			jobapproval: 'JobApproval',
			feedback: 'Suggestion',
		}[value];
		setFilteredSentItems(
			!requestType ? totalSentItems : totalSentItems.filter((item: any) => item.RequestType == requestType),
		);
	};

	const handleCardOpen = (askItem: IAskItems) => {
		setCardOpen(true);
		setCardItem(askItem);
		openAskCard(askItem.RequestType, user.sentItemsCategories);
		let id = askItem.RequestType == 'JobApproval' ? askItem.Details : askItem.Id;
		user.showAskCurrentCard(id, askItem.RequestType);
	};

	const OpenCardComponent = {
		Esme,
		Suggestion,
		Issue,
		JobApproval,
	}[askCategoryName];

	appStores.showAppLoader = user.sentItems === null ? true : false;
	return (
		<div className={classes.frameContainer}>
			<Helmet>
				<title>Sent Items | Aria</title>
			</Helmet>
			<Grid container className={classes.esmeContainer}>
				<Box className={classes.askContainer} m={1}>
					<Grid container className={classes.titleContainer} tabIndex={0} id="SentItems">
						<PageTitle>Sent Items</PageTitle>
						<Grid item xs>
							<FormControl variant="filled" fullWidth className={classes.formControl}>
								<Select
									labelId="reasons-select-label"
									id="reasons-select"
									name="reasons"
									value={reasonValue}
									label="Reasons"
									disableUnderline={true}
									className={focusFormSelect ? classes.focusformSelect : classes.formSelect}
									MenuProps={{
										getContentAnchorEl: null,
										anchorOrigin: {
											vertical: 'bottom',
											horizontal: 'left',
										},
									}}
									onChange={(event: any) => updateFilterValue(event.target.value)}
								>
									<MenuItem value={'all'}>All</MenuItem>
									<MenuItem value={'feedback'}>Feedback</MenuItem>
									<MenuItem value={'jobupdate'}>Job update</MenuItem>
									<MenuItem value={'jobapproval'}>Approval request</MenuItem>
								</Select>
							</FormControl>
						</Grid>
					</Grid>
					<Box className={classes.listContainer}>
						<Box className={classes.askItemsList}>
							{totalSentItems?.length === 0 && (
								<CircularProgress size={'6rem'} style={{ color: '#007DBA', margin: '33%' }} />
							)}
							{filteredSentItems.length > 0 &&
								filteredSentItems.map((askItem: IAskItems, index: number) => (
									<AskItems ask={toJS(askItem)} key={askItem.Id} handleCardOpen={handleCardOpen} />
								))}
							<Grid item container sm={10} justify="flex-end" style={{ padding: '8px' }}>
								<Typography variant="body2" color="primary" style={{ margin: 'auto' }}>
									{user.userSRs.length >= 10 && user.SRsTotalPages !== user.SRspageNo && (
										<Link
											style={{ marginLeft: '50px', cursor: 'pointer', textDecoration: 'none', fontWeight: 'bold' }}
											component="button"
											variant="body2"
											onClick={() => fetchRecentlyCreatedJobs(Number(user.SRspageNo) + 1)}
										>
											{loading ? 'Loading...' : 'Load more jobs'}
										</Link>
									)}
								</Typography>
							</Grid>
						</Box>
					</Box>
				</Box>
				<Box className={classes.openContainer}>
					{!cardOpen && <NoItemSelected setReasonValue={updateFilterValue}></NoItemSelected>}
					{cardOpen && <OpenCardComponent ask={cardItem} />}
				</Box>
			</Grid>
		</div>
	);
});

export default SentItems;
